// Небольшие векторные иллюстрации быстрых действий.
export function ActionArt({ kind }: { kind: "upload" | "calc" | "law" }) {
  return (
    <svg className="tool-art" viewBox="0 0 240 142" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={`paper-${kind}`} x1="78" y1="25" x2="164" y2="126" gradientUnits="userSpaceOnUse"><stop stopColor="#fff" /><stop offset="1" stopColor="#E6F0EB" /></linearGradient>
        <linearGradient id={`green-${kind}`} x1="72" y1="45" x2="158" y2="142" gradientUnits="userSpaceOnUse"><stop stopColor="#549C88" /><stop offset="1" stopColor="#206653" /></linearGradient>
        <filter id={`shadow-${kind}`} x="-50%" y="-30%" width="210%" height="190%"><feDropShadow dx="0" dy="9" stdDeviation="7" floodColor="#194D3D" floodOpacity=".15" /></filter>
      </defs>
      <circle cx="123" cy="70" r="54" stroke="currentColor" strokeOpacity=".08" />
      <circle cx="123" cy="70" r="68" stroke="currentColor" strokeOpacity=".05" />
      {kind === "upload" ? (
        <>
          <g filter="url(#shadow-upload)">
            <rect x="84" y="27" width="73" height="90" rx="7" fill="#A7C9BD" transform="rotate(-13 84 27)" />
            <path d="M100 19h42l21 21v74a6 6 0 0 1-6 6h-57a6 6 0 0 1-6-6V25a6 6 0 0 1 6-6Z" fill="url(#paper-upload)" />
            <path d="M142 19v15a6 6 0 0 0 6 6h15" fill="#CADFD5" />
            <path d="M108 52h39M108 62h39M108 72h25" stroke="#ADC8BC" strokeWidth="4" strokeLinecap="round" />
            <path d="M69 89h106l-9 35a7 7 0 0 1-7 5H85a7 7 0 0 1-7-5Z" fill="url(#green-upload)" />
            <path d="M69 89h32l6 12h29l7-12h32" stroke="#79AE9B" strokeWidth="3" strokeLinejoin="round" />
          </g>
          <circle cx="170" cy="41" r="17" fill="#D7B676" />
          <path d="M170 49V33m-6 6 6-6 6 6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </>
      ) : kind === "law" ? (
        <>
          <g filter="url(#shadow-law)">
            <path d="M121 36c-15-9-35-11-52-5v80c17-6 37-4 52 5Z" fill="url(#paper-law)" />
            <path d="M121 36c15-9 35-11 52-5v80c-17-6-37-4-52 5Z" fill="url(#paper-law)" />
            <path d="M121 36v80" stroke="#ADC8BC" strokeWidth="2.5" />
            <path d="M80 51c10-3 21-2 31 2M80 63c10-3 21-2 31 2M80 75c10-3 21-2 31 2M131 53c10-4 21-5 31-2M131 65c10-4 21-5 31-2M131 77c10-4 21-5 31-2"
              stroke="#ADC8BC" strokeWidth="3.5" strokeLinecap="round" />
            <path d="M63 112c19-7 41-6 58 4 17-10 39-11 58-4v9c-19-7-41-6-58 4-17-10-39-11-58-4Z" fill="url(#green-law)" />
          </g>
          <circle cx="174" cy="39" r="17" fill="#D7B676" />
          <text x="174" y="46" textAnchor="middle" fontSize="20" fontWeight="700" fill="#fff">§</text>
        </>
      ) : (
        <>
          <g filter="url(#shadow-calc)" transform="rotate(9 121 72)">
            <rect x="81" y="17" width="78" height="109" rx="13" fill="#1C594A" />
            <rect x="78" y="13" width="78" height="109" rx="13" fill="url(#green-calc)" />
            <rect x="88" y="25" width="58" height="29" rx="5" fill="#E9F1DC" />
            <path d="M101 44h4m7 0h4m7 0h4m7 0h3" stroke="#63866B" strokeWidth="3" strokeLinecap="round" />
            <g fill="#CBE0D7"><rect x="89" y="64" width="12" height="11" rx="3" /><rect x="110" y="64" width="12" height="11" rx="3" /><rect x="89" y="81" width="12" height="11" rx="3" /><rect x="110" y="81" width="12" height="11" rx="3" /><rect x="89" y="98" width="12" height="11" rx="3" /><rect x="110" y="98" width="12" height="11" rx="3" /></g>
            <rect x="131" y="64" width="13" height="11" rx="3" fill="#DDBE7D" /><rect x="131" y="81" width="13" height="28" rx="3" fill="#DDBE7D" />
          </g>
          <circle cx="174" cy="105" r="19" fill="#DDBE7D" stroke="#EED7A7" strokeWidth="3" />
          <path d="M171 115V95h5a5 5 0 0 1 0 10h-9m0 5h10" stroke="#926E31" strokeWidth="2" strokeLinecap="round" />
        </>
      )}
      <path d="M51 47v8m-4-4h8M192 69v6m-3-3h6" stroke="currentColor" strokeOpacity=".28" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
